import { Fragment } from 'react';

import DialogBase, {
	DialogCloseButton,
	DialogContent as DialogContentBase,
	DialogTop as DialogTopBase
} from '@/components/Dialog';
import { SHEET_VARIANTS, Sheet, SheetContent } from '@/components/Sheet';
import { useMediaQuery } from '@/hooks';
import { cn } from '@/utils';

export default function Dialog({ children, ...props }) {
	const smDown = useMediaQuery('smDown');
	const Component = smDown ? Sheet : DialogBase;

	return <Component {...props}>{children}</Component>;
}

export function DialogContent({ children, ...props }) {
	const smDown = useMediaQuery('smDown');
	const Component = smDown ? SheetContent : DialogContentBase;
	const contentProps = smDown
		? { appear: SHEET_VARIANTS.BOTTOM, hasCross: false }
		: {};
	const Close = smDown ? DialogCloseButton : Fragment;

	return (
		<Component {...contentProps} {...props}>
			{props.hasCross && <Close />}
			{children}
		</Component>
	);
}

export function DialogTop({ className, children, ...props }) {
	return (
		<DialogTopBase className={cn('text-sm', className)} {...props}>
			{children}
		</DialogTopBase>
	);
}

export { DialogFooter } from '@/components/Dialog';
